import { FormEvent, useState } from 'react';
import useTableOrder from 'hooks/tableOrder';
import { Specialty } from 'types/specialty';
import { api } from 'services/api';
import { Paginated } from 'types/paginated';

export type SpecialtyQueryParams = {
  name: string;
};

export function useFetchSpecialties() {
  const [specialties, setSpecialties] = useState<Specialty[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [rows, setRows] = useState<number>(96);
  const [total, setTotal] = useState<number>(0);
  const [orderedIndex, sort] = useTableOrder();
  const [filter, setFilter] = useState<SpecialtyQueryParams>({
    name: '',
  });

  function fetchData(nextPage = page, nextRows = rows, nextFilter = filter) {
    setLoading(true);

    api
      .get<Paginated<Specialty[]>>('/specialties', {
        params: {
          ...nextFilter,
          page: nextPage + 1,
          rows: nextRows,
        },
      })
      .then(response => {
        setTotal(response.data.total);
        setSpecialties(response.data.items);
      })
      .finally(() => setLoading(false));
  }

  function handleSearch(e?: FormEvent<HTMLFormElement>) {
    e?.preventDefault();
    setPage(0);
    fetchData(0, rows, filter);
  }

  function handleChangePage(nextPage: number) {
    setPage(nextPage);
    fetchData(nextPage, rows, filter);
  }

  function handleChangeRows(nextRows: number) {
    setRows(nextRows);
    setPage(0);
    fetchData(0, nextRows, filter);
  }

  function handleSort(index: string) {
    const p = sort(index, specialties);
    setSpecialties(p);
  }

  function handleChange(index: keyof SpecialtyQueryParams, value: string) {
    setFilter(state => ({
      ...state,
      [index]: value,
    }));
  }

  return {
    specialties,
    loading,
    orderedIndex,
    handleSort,
    filter,
    handleChange,
    setPage: handleChangePage,
    setRows: handleChangeRows,
    handleSearch,
    page,
    rows,
    total,
  };
}
